import { connect } from 'react-redux';

import CustomerActions from 'store/customer/actions';
import { actionGetUserGifts } from 'store/gift/actions';

import CustomerDetails from './CustomerDetails';

const mapStateToProps = (state) => ({
  customerDetails: state.customer.customerDetails,
  customerBookings: state.customer.customerBookings,
  totalCustomerBookings: state.customer.totalCustomerBookings,
  customerDetailsLoading: state.customer.customerDetailsLoading,
  customerBookingsLoading: state.customer.customerBookingsLoading,
  userGifts: state.Gift.userGifts,
  getUserGiftsLoading: state.Gift.getUserGiftsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerDetails: (payload) => dispatch(CustomerActions.getCustomerDetails(payload)),
  getCustomerBookings: (payload) => dispatch(CustomerActions.getCustomerBookings(payload)),
  blockCustomer: (payload) => dispatch(CustomerActions.blockCustomer(payload)),
  getUserGifts: (payload) => dispatch(actionGetUserGifts(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);
